<template>
  <bizgain-component-layout
    :show-scrollbar="true"
    :is-next-btn-enabled="true"
    :is-content-scrollable="true"
    :is-help-text-disabled="$vuetify.breakpoint.xsOnly && isAgent"
    :is-agent="true"
    :is-content-top="isAgent"
    :for-summary="true"
    :col-width="{
      'mx-5 px-4': !$vuetify.breakpoint.xsOnly,
      'mx-2': $vuetify.breakpoint.xsOnly,
    }"
  >
    <template v-slot:heading>
      <div v-if="$vuetify.breakpoint.mdAndUp && !isAgent">
        {{ $t('message.bizgainOnboarding.summaryPageHeading') }}
      </div>
      <div v-else-if="$vuetify.breakpoint.mdAndUp && isAgent">
        {{ $t('message.bizgainOnboarding.agentSummaryPageHeading') }}
      </div>
      <div v-else-if="$vuetify.breakpoint.smAndDown && isAgent" style="font-size: 16px !important;">
        {{ $t('message.bizgainOnboarding.agentSummaryPageHeading') }}
      </div>
      <div v-else-if="$vuetify.breakpoint.smAndDown && !isAgent">
        {{ $t('message.bizgainOnboarding.agentSummaryPageHeading') }}
      </div>
    </template>
    <template v-slot:sub-heading>
      <div v-if="$vuetify.breakpoint.smAndDown && isAgent" style="font-size: 12px !important; color: black !important;">
        {{ $t('message.bizgainOnboarding.summaryPageSubHeadingMobile') }}
      </div>
    </template>
    <template v-slot:summary-options>
      <summary-options
        @openShareLinkDialog="shareLinkDialog = true"
        @onContinueSignup="onContinueSignup"
        @changeObjective="changeObjective"
        @openRestartDialog="restartDialog = true"
      />
    </template>
    <template v-slot:content>
      <v-layout row wrap>
        <v-flex
          xs12
          class="mb-2"
          :class="{'mx-1': $vuetify.breakpoint.xsOnly, 'mt-4': $vuetify.breakpoint.xsOnly}"
        >
          <v-layout row wrap :class="{'mb-5 pb-2': !$vuetify.breakpoint.xsOnly && isAgent}">
            <v-flex xs12 class="mb-2">
              <business-details />
            </v-flex>
            <v-flex xs12 class="mb-2">
              <campaign-details />
            </v-flex>
            <v-flex xs12 class="mb-2" ref="creative">
              <creative-details />
            </v-flex>
            <v-flex xs12 ref="targeting">
              <targeting-details />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-if="!isAgent">
          <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
            <v-flex :class="{ 'xs2 ': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
              <v-btn
                depressed
                class="mx-0 w-100 next-btn-color primary-btn-xs"
                @click="proceed()"
              >
                {{ $t('message.bizgainOnboarding.next') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-dialog
        persistent
        v-model="shareLinkDialog"
        v-if="shareLinkDialog"
        content-class="edit-dialog"
        :max-width="`${$vuetify.breakpoint.smAndDown ? '90vw' : '500px'}`"
      >
        <share-link-dialog
          :summary-link="summaryLink"
          @closeDialog="
            shareLinkDialog = false"
          class="drop-shadow"
        />
      </v-dialog>
      <v-dialog
        persistent
        v-model="restartDialog"
        v-if="restartDialog"
        content-class="edit-dialog"
        :max-width="`${$vuetify.breakpoint.smAndDown ? '90vw' : '500px'}`"
      >
        <confirm-restart
          @closeDialog="closeRestartDialog"
        />
      </v-dialog>
      <v-dialog
        persistent
        v-model="changeObjectiveDialog"
        v-if="changeObjectiveDialog"
        content-class="edit-dialog"
        :max-width="`${$vuetify.breakpoint.smAndDown ? '90vw' : '500px'}`"
      >
        <confirm-change-objective
          @closeDialog="changeObjectiveDialog = false"
        />
      </v-dialog>
    </template>
    <template v-slot:btn-content>
      <v-flex
        class="pb-3 pt-3 ml-5 mr-5"
        xs12
        v-if="isAgent"
      >
        <summary-options
          @openShareLinkDialog="shareLinkDialog = true"
          @onContinueSignup="onContinueSignup"
          @changeObjective="changeObjective"
          @openRestartDialog="restartDialog = true"
        />
      </v-flex>
    </template>
  </bizgain-component-layout>
</template>
<script>
import BizgainComponentLayout from 'Components/BizgainComponentLayout/BizgainComponentLayout.vue';
import { bizgainOnboardingRoutes } from 'Features/bizgainOnboarding/constants';
import { VBtn, VFlex, VLayout, VDialog } from 'vuetify/lib';
import { mapGetters, mapActions } from 'vuex';
import BusinessDetails from './BusinessDetails.vue';
import SummaryOptions from './SummaryOptions.vue';
import CampaignDetails from './CampaignDetails.vue';
import CreativeDetails from './CreativeDetails.vue';
import TargetingDetails from './TargetingDetails.vue';
import onboardingRedirect from 'Mixins/onboardingRedirect';
import ShareLinkDialog from '../dailogs/shareLinkDialog.vue';
import ConfirmRestart from '../dailogs/confirmRestart.vue';
import ConfirmChangeObjective from '../dailogs/confirmChangeObjective.vue';
import { launchState } from '../../../constants';

export default {
  mixins: [onboardingRedirect],
  components: {
    VLayout,
    VFlex,
    VBtn,
    VDialog,
    BizgainComponentLayout,
    BusinessDetails,
    CampaignDetails,
    TargetingDetails,
    CreativeDetails,
    ShareLinkDialog,
    ConfirmRestart,
    ConfirmChangeObjective,
    SummaryOptions
  },
  data(){
    return {
      bizgainOnboardingRoutes,
      scrollTo: null,
      shareLinkDialog: false,
      summaryLink: 'link',
      agentName: 'name',
      restartDialog: false,
      isIncompleteSignup: false,
      changeObjectiveDialog: false
    }
  },
  created() {
    if(this.businessDetails.launchState < launchState.LOCATIONTARGETING){
      this.isIncompleteSignup = true;
    }
    this.setCurrentRoute(bizgainOnboardingRoutes.Summary.name);
    localStorage.setItem('isAgentFlow', true);
    if(this.$route.params.scroll){
      this.scrollTo = this.$route.params.scroll;
    }
    if(!this.agentId){
      this.agentId = this.businessDetails.queryParameters['agentid'];
    }
    let host = window.location.host;
    this.summaryLink = `https://${host}/signup/summary?sessionId=${this.businessDetails.sessionId}`;
  },
  mounted(){
    if(this.scrollTo){
      this.$nextTick(() => {
        const el = this.$refs[this.scrollTo];
        const scroll = document.getElementById('myscroll');
        if (el) {
          scroll.scrollTo(0, el.offsetTop);
        }
      })
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'businessProfileId', 'signUpDetails', 'portalDomain', 'region', 'regionConfig']),
    isAgent(){
      return !!this.$route.query['agentid'];
    }
  },
  methods: {
    ...mapActions(['setSignUpRequest', 'setCurrentRoute']),
    proceed(){
      this.redirect({ isAppFlow: true }, {}, false, launchState.SIGNUP, null);
    },
    onContinueSignup(){
      if(this.isIncompleteSignup){
        let lastVisitedRoute = JSON.parse(localStorage.getItem('lastVisitedRoute'));
        this.$router.push({ name: lastVisitedRoute.name, params: lastVisitedRoute.params });
      }
    },
    closeRestartDialog(){
      this.restartDialog = false;
    },
    changeObjective(){
      this.changeObjectiveDialog = true;
    }
  },
  mounted() {
    let nextButton = document.getElementById('inspire');
    nextButton.style.overflow = 'auto';
  },
  unmounted() {
    let nextButton = document.getElementById('inspire');
    nextButton.style.overflow = 'hidden';
  }
}
</script>
<style lang="scss" scoped>
  .drop-shadow{
    filter: drop-shadow(0 4 10 #000 25%);
  }
  .active{
    color: #00D0BD;
  }

  .option{
    margin-left: auto;
    margin-right: auto;
  }
  .cursor-pointer{
    cursor: pointer;
  }
</style>